import request from 'sb-request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { shippingForm } from 'pages/paymentNew/SubscribePrototypePage/util/forms'
import { object, constants, getAbValue } from 'common/helpers'
import { getCookieValue, getFeatureToggle } from 'helpers'
import { getBillData as getSubscribePageBillData } from 'pages/paymentNew/SubscribePrototypePage/util/bill'


const getAddressFieldValues = () => {
  const fieldNames = [ 'street', 'zipCode', 'state', 'city' ]
  const result = {}

  fieldNames.forEach((fieldName) => {
    result[fieldName] = shippingForm.fields[fieldName].value
  })

  return result
}

const checkIsPriceTestEnabled = (couponCode) => {
  const referrerLandingPageURL  = getCookieValue(constants.cookieNames.referrerLandingPageURL) || ''
  const specialFlowName         = getCookieValue(constants.cookieNames.specialFlowName)
  const referrer                = referrerLandingPageURL.replace(/.+\.(com|co|net|org)\//, '/')

  return (
    [ '/', '/men' ].includes(referrer)
    && specialFlowName === constants.specialFlowNames.facebook
    && couponCode === constants.discountCoupons['25_off']
  )
}

const getSubscriptionPriceValue = ({ price, couponCode }) => {
  const isPriceTestEnabled = checkIsPriceTestEnabled(couponCode)

  if (isPriceTestEnabled) {
    return ({
      a: price,
      b: 1695,
      c: 1795,
    })[getAbValue(constants.abTests.priceTestMobile)]
  }

  return price
}

const getTotalPriceValue = ({ price, couponCode }) => {
  const isPriceTestEnabled = checkIsPriceTestEnabled(couponCode)

  if (isPriceTestEnabled) {
    return ({
      a: price,
      b: 1271,
      c: 1346,
    })[getAbValue(constants.abTests.priceTestMobile)]
  }

  return price
}

const setBillItems = () => {
  const {
    models: { me: { gender } },
    view: { paymentPage: { selectedPlan } },
  } = getState()

  setInquireAndBillData({ gender, selectedPlan, inquireData: { coupon: {} } })
}

const inquireSubscription = (values) => {
  const { offer, coupon, subscriptionCase, couponCode, couponType = 'order', plan } = values
  const { view: { pickPage: { selectedItems = [] } } } = getState()

  const isPremiumProductsForNotSubscribedEnabled = getFeatureToggle(constants.features.premiumProductsForNotSubscribed)

  const query = {
    ...getAddressFieldValues(),
    subscriptionCase,
    plan,
  }

  if (isPremiumProductsForNotSubscribedEnabled && selectedItems.length) {
    query.pickedProducts = selectedItems.map(({ id }) => id).join()
  }

  if (offer) {
    query.offer = offer
  }

  if (coupon && coupon.id) {
    query.coupon = coupon.id
  }

  if (couponCode) {
    query.couponCode = couponCode
  }

  if (couponType) {
    query.couponType = couponType
  }

  // TODO remove getSubscriptionPriceValue and getTotalPriceValue after abTest priceTestMobile will be finished
  return request.get('rest/subscription/inquire', {
    query,
    multiple: false,
    modifyResult: (response) => {
      const {
        subscription, cart, discount, tax, price, upchargePrice,
        coupon: couponCode, discountCode, offer, pickedProducts,
        subscriptionCasePrice,
      } = response

      return {
        subscription: {
          ...object.removeKeys(subscription, 'tax'),
          price: getSubscriptionPriceValue({ price: subscription.price, couponCode }),
        },
        cart: cart || {},
        bill: {
          price: getTotalPriceValue({ price, couponCode }),
          upchargePrice,
          discount,
          offer,
          tax,
        },
        coupon: {
          isFetching: false,
          code: couponCode,
          errors: discountCode && discountCode.errors ? discountCode.errors : null,
        },
        pickedProducts,
        subscriptionCasePrice,
      }
    },
  })
}

const setInquireFetchingStatus  = reducers.view.subscribePrototypePage.setInquireFetchingStatus
const setOutOfStockProducts     = reducers.view.subscribePrototypePage.setOutOfStockProducts
const setPaymentMethod          = reducers.view.subscribePrototypePage.setPaymentMethod

const setIsShippingValid        = (isValid) => {
  actions.misc.cookies.setItem(constants.cookieNames.isShippingFormValid, true)
  reducers.view.subscribePrototypePage.setIsShippingValid(isValid)
}

const setInquireAndBillData     = ({ gender, selectedPlan, inquireData }) => {
  const bill = getSubscribePageBillData({ ...inquireData, gender, selectedPlan })

  reducers.view.subscribePrototypePage.setInquireAndBillData({ bill, inquireData })
}


export default {
  inquireSubscription,
  setInquireFetchingStatus,
  setInquireAndBillData,
  setOutOfStockProducts,
  setIsShippingValid,
  setPaymentMethod,
  setBillItems,
}
